<template>
  <div id="app">
    <top-panel></top-panel>
    <router-view/>
  </div>
</template>

<script>
import TopPanel from '@/components/TopPanel.vue'
import { mapMutations } from 'vuex';
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';

export default {
  name: 'app',
  components: {
    TopPanel,
  },

  computed: {
    ...mapGetters([
    ]),    
  },

  methods: {
    ...mapMutations([
    ]),

    ...mapActions([
      'inspectToken',
      'FETCHuserProfile',
    ]),
  },

  async mounted() {
    let status = await this.inspectToken()
    if (status) {
      this.FETCHuserProfile()
    }
  },

  async beforeUpdate() {
    await this.inspectToken()
  },
}
</script>

<style>
.modal-title, .modal-body {
  text-align: center !important;
}

#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background: white;
}
.svg-inline--fa {
  color: grey;
}

.row-selected {
background-color: #f2f2f2;
color: #000000;
font-weight: bold;
}

.form-control {
  height: 2em !important;
}

body {
  line-height:1;
}

.control-panel {
  padding-left: 0px;
}
</style>
